// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21 7H22V9H21V20H22V22H16.5V16.5C16.5 14.0147 14.4853 12 12 12C9.51472 12 7.5 14.0147 7.5 16.5V22H2V20H3V9H2V7H3V6C3 3.79086 4.79086 2 7 2H17C19.2091 2 21 3.79086 21 6V7ZM7 4C5.89543 4 5 4.89543 5 6V7H8V4H7ZM10 4V7H14V4H10ZM16 4V7H19V6C19 4.89543 18.1046 4 17 4H16Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 14C10.6193 14 9.5 15.1193 9.5 16.5V22H14.5V16.5C14.5 15.1193 13.3807 14 12 14Z"}}]};

const Shop4FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'shop-4-filled',
    ref,
    icon: element,
  },
));

Shop4FilledIcon.displayName = 'Shop4FilledIcon';

export default Shop4FilledIcon;
